module.exports = __webpack_public_path__ + "img/liangcang.9ddf01f3.png";